The `CandidateProfile` for the given `id`.

This includes profiles:

- Uploaded candidate profiles from the hirer's ATS
- SEEK candidate profiles available for prefill based on Apply with SEEK consent
- SEEK candidate profiles available for export based on a job application
